import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Users } from "lucide-react";
import api from "../../lib/api";

/** Studio landing entry to the Collaborations inbox, with pending badge. */
export const CollabEntry = () => {
  const [pending, setPending] = useState(0);
  useEffect(() => {
    api.get("/studio/collaborations").then((r) => setPending(r.data.pending_count || 0)).catch(() => {});
  }, []);
  return (
    <Link to="/studio/collaborations"
      className="mb-6 flex items-center gap-3 p-3 rounded-xl border border-white/10 bg-white/[0.03] hover:border-fuchsia-400/40 transition-colors"
      data-testid="studio-collab-entry">
      <span className="w-9 h-9 rounded-full bg-fuchsia-600/20 flex items-center justify-center"><Users className="w-4 h-4 text-fuchsia-300" /></span>
      <span className="flex-1">
        <span className="block text-sm font-bold">Studio Collaborations</span>
        <span className="block text-[11px] text-gray-400">Invites, shared sessions and collaborators</span>
      </span>
      {pending > 0 && (
        <span className="min-w-6 h-6 px-2 rounded-full bg-emerald-500 text-black text-xs font-black flex items-center justify-center"
          data-testid="studio-collab-pending-badge">{pending}</span>
      )}
    </Link>
  );
};

export default CollabEntry;
